/* eslint-disable */
import { ReactSVG } from 'react-svg';
import React from 'react';
import styles from './MajorJobsByDiscipline.module.css';
import classNames from 'classnames/bind';
import sitemapClasses from '../../css/sitemap.module.css';

let cx = classNames.bind(styles);

const defaultMajorClasses = 'industry-icon-shape';
const majorClolors = [
  'icon-accounting-major',
  'icon-blue-major',
  'icon-red-major',
  'icon-orange-major',
  'icon-green-major',
  'icon-education-major',
  'icon-finance-major',
  'icon-lgreen-major',
  'icon-lred-major',
  'icon-mechanical-engineering-major',
  'icon-political-science-major',
  'icon-social-work-major',
  'icon-sociology-major',
];
const randomColor = () => {
  const num = Math.floor(Math.random() * (majorClolors.length - 1 - 0 + 1) + 0);
  return majorClolors[num] || 'icon-sociology-major';
};

const MajorJobsByDiscipline = (props) => {
  const {
    isHomePage,
    majorIndustryList,
    isExplorePage,
    customTitle,
    showAllMajorsLink = true,
  } = props;

  return (
    <section
      className={classNames(
        'section',
        styles['industries-sec'],
        { '': isHomePage },
        { [sitemapClasses['siteMapTopLevelCareer']]: !isHomePage }
      )}
    >
      <div className="container">
        {customTitle ? (
          customTitle
        ) : isHomePage ? (
          <div className="col-lg-12 main_inner">
            <h2 className="brandonH2 sec-head pr-15">Major Jobs By Discipline</h2>
          </div>
        ) : isExplorePage ? (
          <div className="col-lg-12">
            <h2 className="sectionTitle brandonH1">Major Jobs By Discipline</h2>
          </div>
        ) : (
          <div className="col-lg-12">
            <h2 className="brandonH2 mt-3">Major Jobs By Discipline</h2>
          </div>
        )}
        <div className={`${styles['sec-body']} col-lg-12`}>
          <ul className="listWithIcons majorListWithIcons row p-0">
            {majorIndustryList.map((major) => {
              const majorClasses = major.majorClasses
                ? major.majorClasses
                : defaultMajorClasses + ' ' + randomColor();
              return (
                <li key={major.majorName} className={cx('noMajorClasses', 'col-12 col-md-4')}>
                  <a href={major.majorLink}>
                    <span className={`${cx(majorClasses.split(' '))} ${majorClasses}`}>
                      {!major.majorClasses && (
                        <span className={`${cx('defaultIconFirstLetter')} font-20 font-weight-600`}>
                          {major.majorName[0]}
                        </span>
                      )}
                      {major.svgLink && (
                        <i className={cx(major.majorClassesParent.split(' '))}>
                          <em>
                            <ReactSVG src={major.svgLink} />
                          </em>
                        </i>
                      )}
                    </span>
                    <span className="list-link industry-title">{`${major.majorName}`}</span>
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
        {showAllMajorsLink && (
          <div className={sitemapClasses['all-majors']}>
            <a style={{ color: '#3174ee' }} href="/majors/">
              All Majors
            </a>
          </div>
        )}
      </div>
    </section>
  );
};
export default MajorJobsByDiscipline;
